import React from 'react'
import {Field} from "../../ui/elements/field";

export const VlogFields = props => {
  const { vlog } = props

  return <>
    <Field type="text" name="title" placeholder="Title" value={vlog?.title}/>
    <Field type="text" name="recorded_on" placeholder="Recorded on" value={vlog?.recorded_on}/>
    <Field type="text" name="croon" placeholder="Add Croon..." value={vlog?.croon}/>
    <Field type="textarea" name="description" label="Description" value={vlog?.description}/>
    <Field type="text" name="youtube_slug" placeholder="Youtube Slug" value={vlog?.youtube_slug}/>
  </>
}
